<div [formGroup]="form" class="form-wrapper">
  <div class="input-wrapper">
    <input type="number"
            [min]="0"
            class="form-control input-field-with-unit--single-char"
            formControlName="days"
            appNumericDirective/>
    <span class="singlechar-unit">d</span>
  </div>
  <div class="input-wrapper">
    <input type="number"
            [min]="0"
            class="form-control input-field-with-unit--single-char"
            formControlName="hours"
            appNumericDirective/>
    <span class="singlechar-unit">h</span>
  </div>
  <div class="input-wrapper">
    <input type="number"
            [min]="0"
            class="form-control input-field-with-unit--wide"
            formControlName="minutes"
            appNumericDirective/>
    <span class="multichar-unit">min</span>
  </div>
</div>
